import * as React from 'react';
import PortfolioItem from "@components/Portfolio/Item";
import { connect } from 'react-redux';
import { StoreState, Portfolio, PieceSlider } from '@store/index';
import { withRouter, Redirect, RouteComponentProps } from 'react-router-dom';
import { Helmet } from "react-helmet";

interface OwnProps extends RouteComponentProps<{item: string}> { }
interface StateProps { 
    porfolio?: Portfolio;
}
type Props = OwnProps & StateProps;

const PortfolioItemContainer: React.SFC<Props> = (props: Props) => {
    const { porfolio } = props;

    if (!porfolio) {
        return <Redirect
            to={{
                pathname: "/portfolio",
                state: { from: props.location }
            }}
        />
    }
    const title = porfolio.name + ' - Portfolio | Full Stack Web Developer, Artificial Intelligence Specialist';
    const url = process.env.REACT_APP_URL + props.location.pathname;
    const sliderPiece = porfolio.pieces.find((piece) => 'slider' === piece.type) as PieceSlider;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={porfolio.description} />

                <meta name="og:title" content={title} />
                <meta name="og:description" content={porfolio.description} />
                <meta name="og:url" content={url} />
                {
                    sliderPiece && sliderPiece.images && sliderPiece.images
                        .reverse().map((image, index) => (<meta key={`image-${index}`} name="og:image" content={image.url} />))
                }
                <meta name="og:image" content={porfolio.cover.url} />
            </Helmet>

            <PortfolioItem porfolio={porfolio} />
        </>
    );
}

export default connect<StateProps, {}, OwnProps>(
    (state: StoreState, props: OwnProps) => (
        { porfolio: state.portfolios.find((portfolio: Portfolio) => portfolio.slug === props.match.params.item) }
    )
)(withRouter(PortfolioItemContainer));



// WEBPACK FOOTER //
// ./src/containers/Portfolio/Item/index.tsx